import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import '../css/Qualification.css'
import '../css/Common-style.css'

const Qualification = ()=>{
    return(
        <section className="qualification section">
            <h1 className="title text-center">QUALIFICATION</h1>

            <div className="qualification-container container">
                <div className="qualification-tabs">
                    <div className="qualification-button button-flex">
                        <i className="fas fa-graduation-cap qualification-icon">Education</i>
                    </div>
                </div>

                <div className="qualification-section">
                    <div className="qualification-content">
                        <div className="qualification-data qualification-data-start">
                            <div className="clg-names-left">
                                <h3 className="qualification-title">Computer Science</h3>
                                <span className="qualification-subtitle">RNSIT - Bangaluru</span>
                                <div className="qualification-calender">
                                    <i className="far fa-calendar-alt calender-icon"></i>
                                    2018 - 2022
                                </div>
                            </div>

                            <div className="line">
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                         <div className="qualification-data">
                             <div></div>
                             <div className="line">
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div className="clg-names-right">
                                <h3 className="qualification-title">Pre-University</h3>
                                <span className="qualification-subtitle">RNS - Kundapura</span>
                                <div className="qualification-calender">
                                    <i className="far fa-calendar-alt calender-icon"></i>
                                    2016 - 2018
                                </div>
                            </div>
                        </div>

                         <div className="qualification-data qualification-data-start">
                            <div className="clg-names-left">
                                <h3 className="qualification-title">Secondary - Education</h3>
                                <span className="qualification-subtitle">GPUC - Uppunda</span>
                                <div className="qualification-calender">
                                    <i className="far fa-calendar-alt calender-icon"></i>
                                    2014 - 2016
                                </div>
                            </div>

                            <div className="line">
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div className="line">
                                <span className="qualification-rounder"></span>
                                {/* <span className="qualification-line"></span> */}
                            </div>
                            <div className="clg-names-right">
                                <h3 className="qualification-title">Primary - Education</h3>
                                <span className="qualification-subtitle">GHPS - Kirimanjeshwara</span>
                                <div className="qualification-calender">
                                    <i className="far fa-calendar-alt calender-icon"></i>
                                    2006 - 2014
                                </div>
                            </div>
                        </div>                
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Qualification;